import axios from 'axios';
import domReady from '../helpers/dom-ready';
import checkUser from '../helpers/check-user';

class WCProductArchive {
  static init(...parameters) {
    return new WCProductArchive(...parameters);
  }

  constructor() {
    this.container = document.querySelector('.product-archive-wrapper');
    if (this.container) {
      this.checkUser();
    }
  }

  checkUser() {
    const restUrl = document.querySelector('meta[name="rest-url"]').getAttribute('content');

    const products = this.container.querySelectorAll('.products .product');

    const regex = /\bpost-\d+\b(?!-thumbnail)/;

    const productIds = [...products]
      .map(
        (product) => [...product.classList].filter((className) => regex.test(className)),
      )
      .flat()
      .map((className) => className.replace('post-', ''));

    checkUser(
      () => {
        axios.get(`${restUrl}brix/v1/product/${productIds.toString()}`)
          .then((productsResponse) => {
            if (productsResponse.data) {
              products.forEach((product) => {
                const productId = [...product.classList]
                  .filter((className) => regex.test(className))[0]
                  .replace('post-', '');

                const priceAmountWrapper = product.querySelector('.price-amount-wrapper');
                const buttonEl = product.querySelector('.add_to_cart_button');
                const quantityEl = product.querySelector('.quantity');
                const productPriceEl = priceAmountWrapper.querySelector('.product-price');
                const productAmountEl = priceAmountWrapper.querySelector('.product-amount');
                const { formattedPrice, productAmount } = productsResponse.data[productId];

                if (productPriceEl) {
                  productPriceEl.innerHTML = `${formattedPrice} ${productPriceEl.innerHTML}`;
                }

                if (productAmountEl) {
                  productAmountEl.innerHTML = `${productAmount} ${productAmountEl.innerHTML}`;
                }

                if (priceAmountWrapper) {
                  priceAmountWrapper.classList.remove('-hidden');
                }

                if (buttonEl) {
                  buttonEl.classList.remove('-hidden');
                }

                if (quantityEl) {
                  quantityEl.classList.remove('-hidden');
                }
              });
            }
          })
          .catch((e) => {
            console.log(`Error: ${e}`);
          });
      },
      () => {

      },
    );
  }
}

domReady(() => {
  WCProductArchive.init();
});
